import { Constants } from '@pwc/pwc-deals-web-common';
import _get from 'lodash/get';
import { createSelector } from 'reselect';
import {
  CHART_VIEW_COLUMNS_METADATA_KEY,
  TABLE_VIEW_COLUMNS_METADATA_KEY,
  TIME_PERIOD_FLAGS_KEY,
  TIME_PERIOD_METADATA_BY_CODE_KEY,
  TIME_PERIODS_BY_CODE_KEY,
} from '../utilities/constants';

export const getTimePeriodsByCode = (state) =>
  _get(state, TIME_PERIODS_BY_CODE_KEY, {});

export const getTimePeriodMetadataByCode = (state) =>
  _get(state, TIME_PERIOD_METADATA_BY_CODE_KEY, {});

export const createSelectorGetTimePeriodsForDocumentCode = (documentCode) =>
  createSelector(getTimePeriodsByCode, (timePeriodsByCode) =>
    _get(timePeriodsByCode, documentCode, [])
  );

export const createSelectorGetTimePeriodMetadataForDocumentCode = (
  documentCode
) =>
  createSelector(getTimePeriodMetadataByCode, (timePeriodMetadataByCode) =>
    _get(timePeriodMetadataByCode, documentCode, {})
  );

export const getTimePeriodsForQofE =
  createSelectorGetTimePeriodsForDocumentCode(Constants.QUALITY_OF_EARNINGS);

export const getTimePeriodsForNwC = createSelectorGetTimePeriodsForDocumentCode(
  Constants.NET_WORKING_CAPITAL
);

export const getTimePeriodsForDdl = createSelectorGetTimePeriodsForDocumentCode(
  Constants.DEBT_AND_DEBT_LIKE
);

export const getTimePeriodMetadataForNwc =
  createSelectorGetTimePeriodMetadataForDocumentCode(
    Constants.NET_WORKING_CAPITAL
  );

export const getTableTimePeriodsMetadataForNwc = createSelector(
  getTimePeriodMetadataForNwc,
  (nwcTimePeriodMetadata) =>
    _get(
      nwcTimePeriodMetadata,
      [TIME_PERIOD_FLAGS_KEY, TABLE_VIEW_COLUMNS_METADATA_KEY],
      []
    )
);

export const getChartTimePeriodsMetadataForNwc = createSelector(
  getTimePeriodMetadataForNwc,
  (nwcTimePeriodMetadata) =>
    _get(
      nwcTimePeriodMetadata,
      [TIME_PERIOD_FLAGS_KEY, CHART_VIEW_COLUMNS_METADATA_KEY],
      []
    )
);

const filterActiveTimePeriods = (timePeriods, flags) =>
  timePeriods.filter((_, index) => flags[index]);

export const getActiveTableTimePeriodsForNwc = createSelector(
  getTimePeriodsForNwC,
  getTableTimePeriodsMetadataForNwc,
  filterActiveTimePeriods
);

export const getActiveChartTimePeriodsForNwc = createSelector(
  getTimePeriodsForNwC,
  getChartTimePeriodsMetadataForNwc,
  filterActiveTimePeriods
);
